import { useTranslation } from 'react-i18next';

import { ReactComponent as Icon } from '../../assets/icons/stationCluster.svg';

export default function () {
  const { t } = useTranslation('cluster');

  return <Icon className="MuiSvgIcon-root" alt="station-cluster" aria-label={t('Stationscluster')} />;
}
